import React, { FC } from 'react'
import { Box, Grid, Image } from '@gassan-ui'
import { Heading, Text } from '@rolex-ui'
import { useLocalization } from '@components/Localization'
import { rem } from 'polished'

type Props = {
  reference?: string
  modelCase?: string
  bezel?: string
  waterResistance?: string
  movement?: string
  calibre?: string
  powerReserve?: string
  bracelet?: string
  dial?: string
  certification?: string
  title?: string
  sources: string[]
  placeholderSrc: string
}

const Item: FC<{ title: string }> = ({ title, children }) => (
  <Box mb="2vh">
    <Heading variant="smallTitle" display="block" mb="0">
      {title.toUpperCase()}
    </Heading>
    <Text>{children}</Text>
  </Box>
)

const ProductProperties: FC<Props> = ({
  reference,
  modelCase,
  bezel,
  waterResistance,
  movement,
  calibre,
  powerReserve,
  bracelet,
  dial,
  certification,
  title,
  sources,
  placeholderSrc
}) => {
  const { messages } = useLocalization()
  return (
    <Grid
      ml="5vw"
      mr="5vw"
      gridTemplateColumns={{
        _: '1fr',
        large: '50vw 45vw'
      }}
      gridColumnGap="0"
      gridRowGap="1.25rem"
      alignItems="center"
      mt="5vw"
    >
      <Box order={[0, 1]} display="flex" alignItems="center" maxWidth={rem(1000)}>
        <Image
          sources={sources}
          placeholderSrc={placeholderSrc}
          loading="lazy"
          alt={title}
          ratio={1}
        />
      </Box>
      <Box
        order={[1, 0]}
        py={['1.875rem']}
        display="flex"
        justifyContent={['flex-start', 'center']}
      >
        <Box>
          {reference && <Item title={messages.rolex.specs.reference}>{reference}</Item>}
          {modelCase && <Item title={messages.rolex.specs.modelCase}>{modelCase}</Item>}
          {bezel && <Item title={messages.rolex.specs.bezel}>{bezel}</Item>}
          {waterResistance && (
            <Item title={messages.rolex.specs.waterResistance}>{waterResistance}</Item>
          )}
          {movement && <Item title={messages.rolex.specs.movement}>{movement}</Item>}
          {calibre && <Item title={messages.rolex.specs.calibre}>{calibre}</Item>}
          {powerReserve && <Item title={messages.rolex.specs.powerReserve}>{powerReserve}</Item>}
          {bracelet && <Item title={messages.rolex.specs.bracelet}>{bracelet}</Item>}
          {dial && <Item title={messages.rolex.specs.dial}>{dial}</Item>}
          {certification && <Item title={messages.rolex.specs.certification}>{certification}</Item>}
        </Box>
      </Box>
    </Grid>
  )
}

export default ProductProperties
